import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_16 implements Validator {

    public static id = 'CTRL_16';
    private message = 'error.ctr_16';


    public LOG: LogService = new LogService(CTRL_16);

    /**
    * Vérifie que la date donnée en paramètre est bien renseignée
    * @param value
    * @private
    */
    private isDateFilled(value: any): boolean {
      return value !== null && value !== undefined && value !== '' && value !== 'yyyy-MM-dd';
    }

    /**
    * Vérifie que le nombre de jours/mois est bien renseigné
    * @param value
    * @private
    */
    private isDelayFilled(value: any): boolean {
      return value !== null && value !== undefined && value !== '' && value !== 0 && value !== '0';
    }


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_16.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const fourthNameWithStepId = map.get(ctrl.value.rgCtrls.fourthChamp);
                const firstCtrl = form.controls[firstNameWithStepId];
                const secondCtrl = form.controls[secondNameWithStepId];
                const thirdCtrl = form.controls[thirdNameWithStepId];
                const fourthCtrl = form.controls[fourthNameWithStepId];

                // Au moins l'une des dates de début ou de fin est renseignée
                const dateRenseignee = this.isDateFilled(firstCtrl.value) || this.isDateFilled(secondCtrl.value);

                // Au moins un champ délai (mois ou jour) est renseigné
                const delaiRenseigne = this.isDelayFilled(thirdCtrl.value) || this.isDelayFilled(fourthCtrl.value);

                // L'utilisateur peut soit renseigner les dates de début et de fin, soit renseigner le nombre de mois et de jours, mais pas les deux modes simultanément.
                if (dateRenseignee && delaiRenseigne) {
                  // placer le message d'erreur : les deux modes sont renseignés simultanément
                  form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                  form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
